export const events = {
  goToItInventory: 'Go to It Inventory',
  importAssets: {
    importStar: 'Import equipment star',
    addFile: 'Add a file',
    userCompleteTheImport: 'User complete the import',
    error: 'Failed to import equipment',
  },
  newDevice: {
    createEquipment: 'Create equipment',
    createEquipmentAssignation: 'Create equipment assignation',
    createEquipmentSubmit: 'Create equipment submit',
    success: 'Equipment created successfully',
    error: 'Failed to create equipment',
  },
  assigmentEquipment: {
    startTable: 'Assign equipment start table',
    startDetail: 'Assign equipment start details',
    submit: 'Assign equipment submit',
    success: 'Equipment assigned successfully',
    error: 'Failed to assign equipment',
  },
  searchForInventory: 'Search for inventory',
  itAssetDocument: {
    goToPeopleTab: 'Go to IT - People Tab',
    sendDocumentForSignature: 'Send Document for Signature',
    viewItDocuments: 'View IT Documents',
  },
  deviceCatalogEvents: {
    goToDeviceCatalog: 'Go to Device catalog',
    goToDeviceDetail: 'Go to device detail',
    requestDeviceStart: 'Request device start',
    requestDeviceSubmit: 'Request device submit',
    requestDeviceSuccess: 'Request device success',
    requestDeviceClose: 'Request device close',
    requestDeviceError: 'Request device error',
  },
}
